/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Claim_Ticket_Not_RetryableInputs */

const en_error_claim_ticket_not_retryable = /** @type {(inputs: Error_Claim_Ticket_Not_RetryableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only a claim whose ticket could not be opened is sent again.`)
};

/**
* | output |
* | --- |
* | "Only a claim whose ticket could not be opened is sent again." |
*
* @param {Error_Claim_Ticket_Not_RetryableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_claim_ticket_not_retryable = /** @type {((inputs?: Error_Claim_Ticket_Not_RetryableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Claim_Ticket_Not_RetryableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_claim_ticket_not_retryable(inputs)
});